module.exports = __webpack_public_path__ + "static/img/114.115.208.96.5735322c.png";